/** @jsxImportSource @emotion/react */
import React from 'react'
import { compose } from 'ramda'
import { css } from '@emotion/react'
import { createEditor } from 'slate'
import { COLORS } from '@btime/constants'
import { Editable, Slate, withReact } from 'slate-react'

import { Absolute, Relative } from '../../../kiti/components/helpers/Position'
import { deserializeText, serializeText } from '../_serializers/textSerializer'
import { renderElement, renderLeaf } from '../_plugins/plugins'
import { useEditorKeydown } from '../_plugins/keydowns'
import EditorContext from '../EditorContext'
import InterpolationPlugin from '../_plugins/InterpolationPlugin'
import Panel from '../../../kiti/components/structure/Panel'
import Separator from '../../../kiti/components/helpers/Separator'
import Icon from '../../../kiti/components/shapes/Icon'

const EmailInputWithInterpolation = ({ value, onChange, interpolations, customTypes }) => {
  const styles = css`
    & .panel {
      border-color: ${COLORS.light5};
    }
    & .leftContent {
      position: absolute;
      bottom: 0;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3rem;
      left: 0;
      z-index: 10;
    }
    & .inputWrapper {
      padding-left: 3rem;
    }
  `
  const [editor] = React.useState(() =>
    compose(InterpolationPlugin.extend({ fullControl: false }), withReact)(createEditor())
  )

  editor.singleLine = true

  const availableTypes = ['string', 'text', ...(customTypes ?? [])]
  const onlyTextInterpolations = interpolations.filter(interpolation => availableTypes.includes(interpolation?.type))

  const initialValue = deserializeText(value || '', onlyTextInterpolations)

  return (
    <div css={styles}>
      <Panel padding={0} radius={0.4}>
        <Slate editor={editor} value={initialValue} onChange={compose(onChange, serializeText)}>
          <EditorContext size="small">
            <Relative zIndex="auto">
              <Separator className="inputWrapper" paddingV={0.6} paddingH={0.7}>
                <Editable onKeyDown={useEditorKeydown(editor)} renderElement={renderElement} renderLeaf={renderLeaf} />
                <div className="leftContent">
                  <Icon name="BsEnvelope" color={COLORS.dark3} size="1rem" />
                </div>
                <Absolute right={0} top={-1.5} zIndex="auto">
                  <InterpolationPlugin.Dropdown options={onlyTextInterpolations} />
                </Absolute>
              </Separator>
            </Relative>
          </EditorContext>
        </Slate>
      </Panel>
    </div>
  )
}

export default EmailInputWithInterpolation
